import React from 'react';
import PropTypes from 'prop-types';
import { Router } from '@reach/router';
import Host from '../../services/HostConnectionService/HostConnectionService';
import Layout from '../Layout/Layout';

import AdminPage from '../AdminPage/AdminPage';
import VoiePage from '../../pages/VOIE/VOIE';
import NewOrderPage from '../../pages/VOIE/NewOrderPage';
import OrderDetailsPage from '../../pages/VOIE/OrderDetailsPage';


const App = () => {
  const host = Host();
  return <PageRouter host={host} />;
};

const PageRouter = (props) => {
  return (
    <React.Fragment>
      <Layout host={props.host}>
        <Router>
          <Admin path="admin" host={props.host} />
          <Voie path="voie" host={props.host} />
          <VoieNewOrder path="voie/order" host={props.host} />
          <VoieOrderDetails
            path='voie/details/:transactionId'
            host={props.host}
            transactionId={props.transactionId}
          />
        </Router>
      </Layout>
    </React.Fragment>
  );
};

// Page Router interface definition.
PageRouter.propTypes = {
  host: PropTypes.object.isRequired,
  transactionId: PropTypes.string,
};

// Handler to render Login.
// const Login = (props) => {
//   return <LoginPage host={props.host} />;
// };

// Login interface definition.
// Login.propTypes = {
//   host: PropTypes.object.isRequired,
// };

// Handler to render Admin.
const Admin = (props) => {
  return <AdminPage host={props.host} />;
};
 
// Admin interface definition.
Admin.propTypes = {
  host: PropTypes.object.isRequired,
};

//Handler to render Flood.
const Voie = (props) => {
  return <VoiePage host={props.host} />;
};

//Flood interface definition.
Voie.propTypes = {
  host: PropTypes.object.isRequired,
};

// Handler to render Flood New Order Page.
const VoieNewOrder = (props) => {
  return <NewOrderPage host={props.host} />;
};
 
// Flood New Order Page interface definition.
VoieNewOrder.propTypes = {
  host: PropTypes.object.isRequired,
};
 
// Handler to render Flood Order Details Page.
const VoieOrderDetails = (props) => {
  return (
    <OrderDetailsPage host={props.host} transactionId={props.transactionId} />
  );
};
 
// Order Details Page interface definition.
VoieOrderDetails.propTypes = {
  host: PropTypes.object.isRequired,
  transactionId: PropTypes.string,
};
export default App;